import { render, staticRenderFns } from "./claim-return-goods.vue?vue&type=template&id=1aba9ff2&scoped=true&"
import script from "./claim-return-goods.vue?vue&type=script&lang=js&"
export * from "./claim-return-goods.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aba9ff2",
  null
  
)

export default component.exports